import React from 'react';

import { Box, Slider, Stack, Typography } from '@mui/material';

type RawSliderInputProps = {
  label: JSX.Element;
  step?: number;
  marks?: boolean;
  units: string;
  min?: number;
  max?: number;

  value: number;
  onChange: (value: number) => void;
};

export default function RawSliderInput({ label, value, onChange, units, ...props }: RawSliderInputProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={2} justifyContent="space-between" width="100%">
      <Box sx={{ minWidth: 24, lineHeight: 1, flexShrink: 0 }}>{label}</Box>
      <Slider
        {...props}
        value={value}
        onChange={(ev: Event, value: unknown) => {
          onChange(value as number);
        }}
      />
      <Box sx={{ minWidth: 32, textAlign: 'right', flexShrink: 0 }}>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1 }}>
          {value}
          {units}
        </Typography>
      </Box>
    </Stack>
  );
}
